import React from 'react'
import { Col, Container, Image, Row } from 'react-bootstrap'
import service1 from "../../../Assets/images/shopify-img/s1.svg"
import service2 from "../../../Assets/images/shopify-img/s2.svg"
import service3 from "../../../Assets/images/shopify-img/s3.svg"
import service4 from "../../../Assets/images/shopify-img/s4.svg"
import service5 from "../../../Assets/images/shopify-img/s5.svg"
import service6 from "../../../Assets/images/shopify-img/s6.svg"
import Slider from 'react-slick'
import { isMobile } from 'react-device-detect'
import { tr } from 'date-fns/locale'



const ShopifyServices = () => {
    var settings = {
        dots: false,
        arrows:false,
        infinite: true,
        autoplay: true,
        speed: 1000,
        slidesToShow: 4,
        slidesToScroll: 1,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 1,
                    dots: false,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1,
                    dots: true,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                }
            }
        ]
    };
    const shopifyServices = [
        {
            title: "Custom Store Development",
            description: "Make your brand come to life with a Shopify store that is tailored to create a seamless shopping experience and leave a lasting impression on customers.",
            img: service1
        },
        {
            title: "Theme Customization",
            description: "Customize any Shopify theme to align with your brand’s voice, style, and spirit, as your store needs to reflect your unique identity.",
            img: service2
        },
        {
            title: "App Integration",
            description: "Enhance your Shopify store by integrating top-performing apps that increase functionality, drive sales, and keep your customers coming back.",
            img: service3
        },
        {
            title: "Migration to Shopify",
            description: "We handle smooth, stress-free migrations to Shopify, protecting every product, customer record, and precious detail.",
            img: service4
        },
        {
            title: "SEO & Performance",
            description: "Enhance your store’s visibility and speed through professional Shopify SEO and performance optimization designed for improved rankings and increased sales.",
            img: service5
        },
        {
            title: "Support & Maintenance",
            description: "Your Shopify store requires ongoing attention, we provide proactive assistance, upgrades, and solutions to ensure your business operates seamlessly.",
            img: service6
        }
    ];
    return (
        <div className='bwn_shopify_services_section'>
            <Container className='bw_custome_footer_container '>
                <Row>
                    <Col sm={12} md={12} lg={12}>
                        <div className='bwn_shopify_services_section_heading text-center'>
                            <h2 className='sho_heading'>Our Shopify Development Services</h2>
                            <p className='sho_sub_heading'>Transforming Your Shopify Store into a Revenue-Generating Machine</p>
                        </div>
                    </Col>
                </Row>
              {isMobile ? 
              <Row>
                    <Col sm={12} md={12} lg={12}>
                        <Slider {...settings}>
                            {shopifyServices.map((val, index) => (
                                <div>
                                    <div className='bwn_shopify_services_section_box'>
                                        <Image src={val.img} className='img-fluid' />
                                        <h2>
                                            {val.title}
                                        </h2>
                                        <p>{val.description}</p>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </Col>
                </Row>
                 : 
<Row>
                    {shopifyServices.map((val, index) => (
                        <Col sm={12} md={4} lg={4}>
                            <div className='bwn_shopify_services_section_box'>
                                <Image src={val.img} className='img-fluid' />
                                <h2>
                                    {val.title}
                                </h2>
                                <p>{val.description}</p>
                            </div>
                        </Col>
                    ))}
                </Row>
                }  
                
            </Container>
        </div>
    )
}

export default ShopifyServices